<template>
  <div class="template-quiz-questions">
    <PolarArea
      :chart-options="chartOptions"
      :chart-data="chartData"
      chart-id="polar-chart"
      dataset-id-key="label"
      :width="400"
      :height="400"
    />

    <div class="question" v-for="question in questions" :key="question.id">
      <div class="question-name">
        {{ question.name }}
      </div>
      <vue-slider
        v-model="form[question.id]"
        :min="question.score_min"
        :max="question.score_max"
        :process-style="style(question)"
        :dot-style="style(question)"
        :duration="0.1"
        class="mb-2"
        :marks="
          () => ({
            activeStyle: style(question)
          })
        "
      />
    </div>

    <button
      class="btn btn-primary btn-block btn-strong rounded-pill mt-5"
      @click="submit"
    >
      <loading :show="loading">
        Salvar
      </loading>
    </button>
  </div>
</template>

<script>
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";
import { PolarArea } from "vue-chartjs/legacy";
import get from "lodash/get";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  RadialLinearScale
} from "chart.js";

ChartJS.register(Title, Tooltip, Legend, ArcElement, RadialLinearScale);

export default {
  components: { VueSlider, PolarArea },
  props: {
    questions: Array,
    answers: Array
  },
  data() {
    const answerIds = {};
    const form = {};
    if (this.answers) {
      this.answers.forEach(a => {
        form[a.question_id] = a.score;
        answerIds[a.question_id] = a.id;
      });
    } else {
      this.questions.forEach(q => (form[q.id] = 0));
    }

    return {
      loading: false,
      form,
      answerIds,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          }
        },
        scales: {
          r: {
            min: 0,
            max: 10,
            ticks: {
              stepSize: 1,
              color: "white",
              backdropColor: "rgba(0,0,0,0)"
            },
            grid: {
              color: "#fff8"
            }
          }
        }
      }
    };
  },
  computed: {
    chartData() {
      return {
        labels: this.questions.map(q => q.name),
        datasets: this.questions.map((q, index) => {
          const data = Array(this.questions.length).fill(0);
          data[index] = this.form[q.id];
          return {
            label: q.name,
            backgroundColor: q.hex_color,
            pointBackgroundColor: q.hex_color,
            pointHoverBorderColor: q.hex_color,
            data
          };
        })
      };
    }
  },
  methods: {
    style(question) {
      return {
        "background-color": question.hex_color,
        "border-color": question.hex_color
      };
    },
    submit() {
      const data = this.questions.map(q => ({
        question_id: q.id,
        score: this.form[q.id],
        id: this.answerIds[q.id]
      }));

      const action = this.answers ? "quiz/updateAnswers" : "quiz/postAnswers";

      this.loading = true;
      this.$store
        .dispatch(action, data)
        .then(() => {
          this.$message.success("Questionário salvo com sucesso!");
          this.$emit("success");
        })
        .catch(error => {
          this.$message.error(
            get(error, "response.data.message", "Erro ao salvar questionário.")
          );
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.template-quiz-questions {
  padding: 8px;

  .question {
    padding: 16px;

    .question-name {
      font-size: 14px;
      margin-bottom: 14px;
      font-weight: 500;
      text-align: center;
    }
  }
}
</style>
